import * as Yup from 'yup'

const yupDMS = Yup.object().shape({
  formInput: Yup.object().shape({
    adjustmentReason: Yup.string().required('Plese Enter Adjustment Reason'),
  }),
})

export default yupDMS
